// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ArrowSlantDownLeft(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowSlantDownLeft" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M21.5 3.90712L7.11831 18.3029L11.7351 18.3029V21H2.5V11.83H5.21622L5.21622 16.3772L19.5793 2L21.5 3.90712Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ArrowSlantDownLeft.js.map